import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Rider\OrderController::index
* @see app/Http/Controllers/Rider/OrderController.php:18
* @route '/profil/objednavky'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/profil/objednavky',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Rider\OrderController::index
* @see app/Http/Controllers/Rider/OrderController.php:18
* @route '/profil/objednavky'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\OrderController::index
* @see app/Http/Controllers/Rider/OrderController.php:18
* @route '/profil/objednavky'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::index
* @see app/Http/Controllers/Rider/OrderController.php:18
* @route '/profil/objednavky'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::index
* @see app/Http/Controllers/Rider/OrderController.php:18
* @route '/profil/objednavky'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::index
* @see app/Http/Controllers/Rider/OrderController.php:18
* @route '/profil/objednavky'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::index
* @see app/Http/Controllers/Rider/OrderController.php:18
* @route '/profil/objednavky'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Rider\OrderController::show
* @see app/Http/Controllers/Rider/OrderController.php:30
* @route '/profil/objednavky/{order}'
*/
export const show = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/profil/objednavky/{order}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Rider\OrderController::show
* @see app/Http/Controllers/Rider/OrderController.php:30
* @route '/profil/objednavky/{order}'
*/
show.url = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        order: typeof args.order === 'object'
        ? args.order.id
        : args.order,
    }

    return show.definition.url
            .replace('{order}', parsedArgs.order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\OrderController::show
* @see app/Http/Controllers/Rider/OrderController.php:30
* @route '/profil/objednavky/{order}'
*/
show.get = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::show
* @see app/Http/Controllers/Rider/OrderController.php:30
* @route '/profil/objednavky/{order}'
*/
show.head = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::show
* @see app/Http/Controllers/Rider/OrderController.php:30
* @route '/profil/objednavky/{order}'
*/
const showForm = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::show
* @see app/Http/Controllers/Rider/OrderController.php:30
* @route '/profil/objednavky/{order}'
*/
showForm.get = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderController::show
* @see app/Http/Controllers/Rider/OrderController.php:30
* @route '/profil/objednavky/{order}'
*/
showForm.head = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Rider\OrderDownloadController::download
* @see app/Http/Controllers/Rider/OrderDownloadController.php:30
* @route '/profil/objednavky/{order}/stahnout'
*/
export const download = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: '/profil/objednavky/{order}/stahnout',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Rider\OrderDownloadController::download
* @see app/Http/Controllers/Rider/OrderDownloadController.php:30
* @route '/profil/objednavky/{order}/stahnout'
*/
download.url = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        order: typeof args.order === 'object'
        ? args.order.id
        : args.order,
    }

    return download.definition.url
            .replace('{order}', parsedArgs.order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\OrderDownloadController::download
* @see app/Http/Controllers/Rider/OrderDownloadController.php:30
* @route '/profil/objednavky/{order}/stahnout'
*/
download.get = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderDownloadController::download
* @see app/Http/Controllers/Rider/OrderDownloadController.php:30
* @route '/profil/objednavky/{order}/stahnout'
*/
download.head = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Rider\OrderDownloadController::download
* @see app/Http/Controllers/Rider/OrderDownloadController.php:30
* @route '/profil/objednavky/{order}/stahnout'
*/
const downloadForm = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderDownloadController::download
* @see app/Http/Controllers/Rider/OrderDownloadController.php:30
* @route '/profil/objednavky/{order}/stahnout'
*/
downloadForm.get = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Rider\OrderDownloadController::download
* @see app/Http/Controllers/Rider/OrderDownloadController.php:30
* @route '/profil/objednavky/{order}/stahnout'
*/
downloadForm.head = (args: { order: number | { id: number } } | [order: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: download.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

download.form = downloadForm

const orders = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    download: Object.assign(download, download),
}

export default orders